import { useMemo } from 'preact/hooks'
import get from 'lodash-es/get'

import YearArchive from '../../js/components/page/year-archive'
import { mapNodeToArticle } from '../../js/graphql/utils'
import { usePagination } from '../../js/hooks/pagination'
import { YEAR } from '../../js/constants'

export default function Page(props) {
  const { data, year, page } = props

  const hasNext = get(data, 'posts.pageInfo.hasNextPage', false)
  const hasPrev = page > 1

  const entries = useMemo(
    () => {
      const posts = get(data, 'posts.nodes', [])

      return posts.map(mapNodeToArticle)
    },
    [data],
  )

  const rel = usePagination(
    YEAR,
    {
      year,
      page,
      hasNext,
      hasPrev,
    },
  )

  return (
    <YearArchive year={year} rel={rel} entries={entries} />
  )
}
